/**
 * 取り込みの件数のまとめ（docs/01 6-4「登録◯件・更新◯件・無効化◯件・エラー◯件」）。
 *
 * 見込みの画面と、結果の画面と、あとから見返す画面で同じ形で出す（読む方が数え方を覚え直さない）。
 */
import type { ReactNode } from 'react';
import type { RosterSummary } from '../api/types.js';

export function RosterSummaryList({ summary }: { summary: RosterSummary }): ReactNode {
  return (
    <dl className="admin-facts">
      <dt>読み取った行</dt>
      <dd>{summary.rows}行</dd>
      <dt>新しく登録</dt>
      <dd>{summary.created}件</dd>
      <dt>内容を更新</dt>
      <dd>{summary.updated}件</dd>
      <dt>変わらない</dt>
      <dd>{summary.unchanged}件</dd>
      <dt>CSVに載っていなかった方</dt>
      <dd>
        {summary.deactivationCandidates}名<small>自動では無効にしません</small>
      </dd>
      <dt>取り込めない行</dt>
      <dd>{summary.errors}件</dd>
    </dl>
  );
}
